import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { createActionState } from '@at/shared';
import { Trip } from '@at/trip';
import { PeopleApi } from '../../../api';

@Component({
  selector: 'at-leave-trip',
  standalone: true,
  imports: [],
  templateUrl: './leave-trip.component.html',
  styleUrl: './leave-trip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeaveTripComponent {
  #api = inject(PeopleApi);
  #router = inject(Router);
  protected readonly leaveTrip = new Subject<void>();
  public trip = input.required<Trip>();

  protected state = toSignal(
    createActionState({
      trigger: this.leaveTrip,
      apiCall: () => this.#api.leaveTrip(this.trip().tripId),
      onSucceed: async () => await this.#router.navigateByUrl('/home'),
    }),
  );
}
